/**
 * Invoice reference fieldset for XeroManualForm.
 *
 * Contains the Xero Organisation ID, Invoice Number, and advanced UUID fields.
 * Extracted to reduce complexity of the parent form component.
 */

import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import {
  AdvancedDetails,
  InvoiceNumberField,
  OrgIdField,
} from './xero-invoice-reference-fieldset/xero-invoice-reference-fieldset.parts'

interface InvoiceRefFormData {
  xeroOrganisationId: string
  xeroInvoiceNumber: string
  xeroTenantId: string
  xeroInvoiceId: string
}

interface XeroInvoiceReferenceFieldsetProps {
  formData: InvoiceRefFormData
  selectedOrgXeroId?: string | undefined
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
}

export function XeroInvoiceReferenceFieldset({
  formData,
  selectedOrgXeroId,
  onChange,
}: XeroInvoiceReferenceFieldsetProps): ReactElement {
  const { t } = useTranslation('admin')
  return (
    <>
      <fieldset className="space-y-4">
        <legend className="text-sm font-medium text-stone-700 dark:text-stone-300">
          {t('licensing.xero.invoiceReference')}
        </legend>
        <div className="grid gap-4 sm:grid-cols-2">
          <OrgIdField
            value={formData.xeroOrganisationId}
            selectedOrgXeroId={selectedOrgXeroId}
            onChange={onChange}
            t={t}
          />
          <InvoiceNumberField value={formData.xeroInvoiceNumber} onChange={onChange} t={t} />
        </div>
      </fieldset>
      <AdvancedDetails
        tenantId={formData.xeroTenantId}
        invoiceId={formData.xeroInvoiceId}
        onChange={onChange}
        t={t}
      />
    </>
  )
}
